export enum EFilterFetchConvertType {
	date = 'date',
	dateArray = 'dateArray',
	number = 'number',
	numberArray = 'numberArray',
	boolean = 'boolean'
}